import $ from 'jquery'
import RytmWebflow from 'rytm-webflow'
import { trace } from 'rytm-helpers'
import imagesLoaded from 'imagesloaded'

import AmznController from './../AmznController'

class DblimgController extends RytmWebflow.Controller {
  
  
  addEventListeners() { 
    this.isAnimating = false
    this.animationTime = 400
    this.animationTimeout = null
    $("body").on("mouseover", ".img-trigger", $.proxy(this.onImgTriggerClick, this))
  }
  removeEventListeners() {
    $("body").off("mouseover", ".img-trigger", $.proxy(this.onImgTriggerClick, this))
    clearTimeout(this.animationTimeout)
  }

  /**
   * Own
   */
  onImgTriggerClick(e) {
    e.preventDefault();
    const btn = e.currentTarget
    const selector = btn.dataset.target
    if (selector) {
      this.openItem(selector, e)
    }
  }
  
  openItem(selector, e) {
    if (this.isAnimating) {
      trace("is animating", this.isAnimating)
      return false
    }
    const item = document.querySelector(selector)
    if (!item) {
      return false
    }
    if (item.classList.contains("active")) {
      trace("Active item click...")
      return false
    }
    // opening item (event stop propagation – to prevent blueimp gallery open)
    e.stopPropagation()
    this.isAnimating = true
    const listActive = [...document.querySelectorAll('.img-item.active')]
    if (listActive.length > 0) {
      listActive.forEach((it) => {
        it.classList.add("animating")
        it.classList.remove("active")
        // deactivate blueimp gallery
        it.dataset.gallery = null
      })
    }
    item.classList.add("animating")
    item.classList.add("active")
    clearTimeout(this.animationTimeout)
    this.animationTimeout = setTimeout(this.onAnimationTimeout.bind(this), this.animationTime)
  }
  
  onAnimationTimeout(e) {
    const listActive = [...document.querySelectorAll('.img-item.animating')]
    this.isAnimating = false
    if (listActive.length > 0) {
      listActive.forEach((it) => {
        it.classList.remove("animating")
        if (it.classList.contains("active")) {
          // activate blueimp gallery
          setTimeout(() => {
            it.dataset.gallery = "#blueimp-gallery-modal"
          }, 200)
        }
      })
    }
    
  }
  

}

export default DblimgController;